import { limitIndividualRisk, limitOverallRisk } from './';

/**
 * Returns the appropriate risk limiting function based on the cancer type
 * @param cancerType The type of cancer
 * @returns The appropriate risk limiting function
 */
export function getAppropriateRiskLimiter(cancerType?: string) {
  return cancerType === 'overall' ? limitOverallRisk : limitIndividualRisk;
}
